import sortBy from 'lodash.sortby';
import { apiNames, get, fetchQuery } from '@general/api/shared';

export const url = 'countries';
const fetchRequest = () => get(apiNames.MEMBERSHIP, url);

// [{name: "Poland", code: "PL"}, ...]
export const countriesToOptions = data => {
    let countries = data.map(c => ({ label: c.name, value: c.code }));
    // weed out the bad countries for testing
    countries = countries.filter(c => c.value !== '');
    return sortBy(countries, 'label');
};

export const getCountries = ({ transformData }) => fetchQuery({ fetchRequest, transformData });
